<template>
  <v-container class="relative container1400">
    <h2 class="text-h5 mt-6 mb-6 font-weight-regular text-left">
      {{ $t("Cmsg14") }}
    </h2>
    <v-form
      ref="form"
      class="pb-5"
      v-model="valid"
      @submit.prevent="next"
      lazy-validation
    >
      <v-card class="pa-7" min-height="500px">
        <v-row>
          <v-col>
            <v-text-field
              hide-details="auto"
              type="text"
              v-model="data.name"
              :rules="reqRules"
              v-bind:label="$t('PropertyName')"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              hide-details="auto"
              outlined
              v-model="data.teaser"
              v-bind:label="$t('Teaserdescription')"
              :rules="reqRules"
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="overline">
              {{ $t("Detaileddescription") }}
            </div>
            <vue-editor
              v-model="data.description"
              :editor-toolbar="customToolbar"
              :rules="reqRules"
            />
            <div
              v-if="descrError"
              class="v-messages theme--light error--text pt-1 pl-3"
              role="alert"
            >
              {{ $t("AddDescription") }}
            </div>
          </v-col>
        </v-row>
      </v-card>
      <div class="text-right mt-10">
        <v-btn
          outlined
          color="grey"
          large
          class="mr-2"
          @click="$emit('goBack')"
          >{{ $t("Back") }}</v-btn
        >
        <v-btn large color="light-blue white--text" rounded type="submit">
          <span class="mr-2">{{ $t("Continue") }}</span>
          <v-icon size="small">mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  props: ["data"],
  name: "Step5Component",
  components: { VueEditor },
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ],
      descrError: false,
      valid: null,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  methods: {
    async next() {
      await this.$refs.form.validate();
      if (this.data.description == null || this.data.description == "") {
        this.descrError = true;
      } else {
        this.descrError = false;
        if (this.valid && this.descrError == false) {
          window.scrollTo(0, 0);
          return (this.data.steps = 6);
        }
      }
    }
  }
};
</script>

<style scoped>
.ap-input {
  padding-left: 50px;
}
</style>
